import TaskExampleImage from "components/ExampleImage/TaskExampleImage";
import { Flex } from "@chakra-ui/react";
import { useEffect } from "react";
import {
  TemplateTaskActionButton,
  PrebuiltTemplateTaskActionButton,
  PrebuitTaskTemplateActionButtonParentProps,
  TaskTemplateActionButtonParentProps,
  TemplateTaskActionCloseButton,
} from "./TemplateTaskActionButton";
import TemplateActionText from "../TemplateActionText";

export default function TemplateSelectRoleTaskAction({ form, autoOpen, setAutoOpen, onRemove }: TaskTemplateActionButtonParentProps) {
  const { watch } = form;
  const taskAction = watch("taskAction");
  const rolename = taskAction === "assign_buddy" ? "Buddy" : "";
  useEffect(() => {
    if (autoOpen) {
      setAutoOpen(false);
    }
  }, [autoOpen, setAutoOpen]);
  return (
    <TemplateTaskActionButton autoOpen={autoOpen} onRemove={onRemove} buttonText={`${rolename} Select`} buttonTitle={`${rolename} Select`}>
      <Flex direction="column" pb="4" gap="6" w="100%">
        <TemplateActionText text={`Select a ${rolename}`} />
        <TaskExampleImage taskType="assign_buddy" />
      </Flex>
      <TemplateTaskActionCloseButton />
    </TemplateTaskActionButton>
  );
}

export function PrebuiltSelectRoleTaskAction({ prebuiltTaskTemplate }: PrebuitTaskTemplateActionButtonParentProps) {
  const rolename = prebuiltTaskTemplate?.taskAction === "assign_buddy" ? "Buddy" : "";
  return (
    <PrebuiltTemplateTaskActionButton buttonText={`${rolename} Select`} buttonTitle={`${rolename} Select`}>
      <Flex direction="column" pb="4" gap="6" w="100%">
        <TemplateActionText text={`Select a ${rolename}`} />
        <TaskExampleImage taskType="assign_buddy" />
      </Flex>
    </PrebuiltTemplateTaskActionButton>
  );
}
